import { Link, useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import httpService from "../../services/HttpService";
import Header from "../common/Header";
import './OrderSingle.css';
import { formattedPrice } from "../../utils/priceFormatter";

const OrderSingle = ({hideHeader = false}) => {
    const navigate = useNavigate();
    const { orderId } = useParams();
    const [order, setOrder] = useState(null);
    const [notification, setNotification] = useState(null);

    useEffect(() => {
        httpService.get(`/orders/${orderId}`)
            .then((res) => res.json())
            .then((data) => setOrder(data));
    }, [orderId]);

    const back = () => {
        navigate(-1);
      };

    const formatDate = (dateString, section = null) => { // TODO: make global
        const date = new Date(dateString);
        if (section === "header") {
            return date.toLocaleDateString('ru-RU', { month: 'short', day: 'numeric' });
        }
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
      
        return `${year}-${month}-${day}`;
    };

    const handleCopyToClipboard = (orderId) => {
        navigator.clipboard.writeText(orderId)
          .then(() => {
            setNotification('Номер заказа скопирован в буфер обмена');
          })
          .catch((error) => {
            setNotification('Ошибка при копировании: ' + error);
          });

        setTimeout(() => setNotification(null), 3000);
    };
      
    const handleProductRefund = (productId) => {
        navigate(`/refund/${order.id}?product_id=${productId}`);
    };

    if (!order) return <p>Loading order details...</p>;

    return (
        <div>
            {!hideHeader && (
                <Header />
            )}
            <main className="order-main">
                <div className="order-info">
                {!hideHeader && (
                    <div className="order-number">
                        <div onClick={back} className="material-symbols-sharp burger-menu-back-button back">chevron_left</div>
                        <div className="date">Заказ с {formatDate(order.date, 'header')}</div>
                    </div>
                )}
                    <div className="order-info-item">
                        <div className="label">Статус</div>
                        <div className="value green">{order.status}</div>
                    </div>
                    <div className="order-info-item">
                        <div className="label">Номер</div>
                        <div className="value">
                            {order.id}
                            <button 
                                className="copy-icon" 
                                onClick={() => handleCopyToClipboard(order.id)}
                                aria-label="Copy Order ID"
                            >
                                <span className="material-symbols-sharp">content_copy</span>
                            </button>
                        </div>
                    </div>
                    <div className="order-info-item">
                        <div className="label">Адрес</div>
                        <div className="value">{order.address.street}, д. {order.address.house}, к. {order.address.apartment}</div>
                    </div>
                    <div className="order-info-item">
                        <div className="label">Дата покупки</div>
                        <div className="value">{formatDate(order.created_at)}</div>
                    </div>
                    <div className="order-info-item">
                        <div className="label">Дата доставки</div>
                        <div className="value">{order.date}</div>
                    </div>
                    <div className="order-info-item">
                        <div className="label">Оплата</div>
                        <div className="value">{order.card_id}</div>
                    </div>

                    <div className="cart-items-list">
                        {order.products.map((product, index) => (
                            <div key={index} className="cart-item">
                                <div className="cart-item-left">
                                    <Link className="link" to={`/product/${product.id}`}>
                                        <img
                                            src={product.main_image.link}
                                            alt={product.name}
                                            className="cart-item-image"
                                        />
                                    </Link>
                                </div>
                                <div className="order-item-middle">
                                    <p className="cart-item-name">{product.name}</p>
                                    <p className="cart-item-brand-name">{product.brand.name}</p>
                                    <p className="cart-item-size">Size: {product.size}</p>
                                    <p className="order-size">{formattedPrice(product.price, null, product.sale)} {product.actual_price} &#8381;</p>
                                    {!hideHeader && (
                                        <button
                                            className="make-refund"
                                            onClick={() => handleProductRefund(product.id)}
                                        >
                                            Сделать возврат
                                        </button>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                {notification && (
                    <div className="notification">
                        {notification}
                    </div>
                )}
            </main>
        </div>
    );
};

export default OrderSingle;
